/**
 * Cursor surface raycast — module-level callback bridge.
 *
 * The renderer registers a camera-direction raycast implementation via
 * `registerCursorSurfaceRaycast`.  The App-level pointer handler queries it
 * via `queryCursorSurface` to place the 3D cursor on the surface under the
 * mouse (Shift+Right-click).
 *
 * Follows the same bridge pattern as `registerSnapRaycast` in snap.ts.
 */

/** Raycast the scene in camera-direction and return the world-space hit point. */
type CursorSurfaceRaycastFn = (
  ndcX: number,
  ndcY: number,
) => [number, number, number] | null;

let _fn: CursorSurfaceRaycastFn | null = null;

/** Called by the renderer to provide (or remove) the surface raycast implementation. */
export function registerCursorSurfaceRaycast(
  fn: CursorSurfaceRaycastFn | null,
): void {
  _fn = fn;
}

/** Query the surface under (ndcX, ndcY). Returns null when nothing is hit. */
export function queryCursorSurface(
  ndcX: number,
  ndcY: number,
): [number, number, number] | null {
  return _fn?.(ndcX, ndcY) ?? null;
}
